import {HTTP, ERROR} from '@/http-common';

const state = {
    indexGrouped: {
        pending: [],
        enrolled: [],
        not_enrolled: []
    },
    index: {
        'pages': 1,
        'from': null,
        'to': null,
        'referrals': [],
        'total': 0
    },
    loading: {
        indexGrouped: false,
        index: false,
    },
    errors: {
        indexGrouped: false,
        index: false,
    },
};

const mutations = {
    SET_ERROR(state, data) {
        Object.assign(state.errors, data);
    },
    SET_LOADING(state, data) {
        Object.assign(state.loading, data);
    },
    SET_INDEX_GROUPED(state, data) {
        state.indexGrouped = data;
    },
    SET_INDEX(state, data) {
        state.index = data;
    }
};

const getters = {
    getLoading: state => {
        return state.loading;
    },
    getErrors: state => {
        return state.errors;
    },
    getIndexGrouped: state => {
        return state.indexGrouped;
    },
    getIndex: state => {
        return state.index;
    }
};

const actions = {
    fetchIndexGrouped: ({commit, dispatch}) => {
        commit('SET_LOADING', {'indexGrouped': true});
        return HTTP.get('referrals/index-grouped').then(response => {
            ERROR(response);
            if (response.data.status === 'success') {
                commit('SET_INDEX_GROUPED', response.data.data.referrals);
                commit('SET_ERROR', {'indexGrouped': false})
                dispatch('GET_USER_DATA_REFRESH_ACTION', null, { root: true });
            }
        }).catch(err => {
            commit('SET_ERROR', {'indexGrouped': true})
        }).then(() => {
            commit('SET_LOADING', {'indexGrouped': false})
        })
    },
    fetchIndex: ({commit, dispatch}, payload) => {
        commit('SET_LOADING', {'index': true});
        return HTTP.get('referrals/index', {params: payload}).then(response => {
            ERROR(response);
            if (response.data.status === 'success') {
                commit('SET_INDEX', response.data.data);
                commit('SET_ERROR', {'index': false})
                dispatch('GET_USER_DATA_REFRESH_ACTION', null, { root: true });
            }
        }).catch(err => {
            commit('SET_ERROR', {'index': true})
        }).then(() => {
            commit('SET_LOADING', {'index': false})
        })
    },
    exportFeedAsCsv: ({commit}) => {
        commit('SET_LOADING', {'feedCsvExport': true});
        return HTTP.get('referrals/export-feed-as-csv')
    }

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/referrals.js